import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';
import { PasswordValidator } from 'libs/portal/src/validators/password-validator';
import { Endpoints } from '@huge-monorepo/portal/config';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  constructor(
    private toastService: ToastrService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
  ) {}

  passwordControl = new UntypedFormControl('', [Validators.required]);
  @Input() userToReset: any;

  formGroup: UntypedFormGroup = new UntypedFormGroup(
    {
      passwordControl: new UntypedFormControl('', Validators.compose([Validators.minLength(8), Validators.required])),
      confirmPasswordControl: new UntypedFormControl('', [Validators.required]),
    },
    (formGroup: any) => {
      return PasswordValidator.areEqual(formGroup);
    },
  );

  validation_messages = {
    passwordControl: [
      { type: 'required', message: 'Password is required.' },
      {
        type: 'minLength',
        message: 'Please enter a password with more than 8 characters.',
      },
    ],
    matching_passwords: [{ type: 'areEqual', message: 'Password do not match.' }],
    confirm_password: [{ type: 'required', message: 'Confirm password is required.' }],
  };

  async closeModal(isCancelled: boolean) {
    this.dialogRef.close(isCancelled);
  }

  resetPassword() {
    if (this.formGroup.status == 'INVALID') {
      this.formGroup.get('passwordControl').setErrors({ passwordMismatch: true });
    }
    if (
      this.formGroup.get('passwordControl').value == '' ||
      this.formGroup.get('confirmPasswordControl').value == '' ||
      this.formGroup.get('passwordControl').errors != null ||
      this.formGroup.get('confirmPasswordControl').errors != null
    ) {
      this.formGroup.get('passwordControl').markAsTouched();
      this.formGroup.get('confirmPasswordControl').markAsTouched();
    } else {
      this.genericService
        .PUT(this.endpoints.RESET_PASSWORD(this.userToReset.id), {
          password: this.formGroup.get('passwordControl').value,
        })
        .subscribe(() => {
          this.closeModal(false);
          this.toastService.success('', 'Password successfully updated', { timeOut: 4000 });
        });
    }
  }

  ngOnInit() {
    console.log(this.userToReset);
  }
}
